import { IFormData } from './interfaces';

export const serializeForms = (jsonData: any): IFormData[] => {
  let forms: IFormData[] = [];

  for (let form of jsonData) {
    forms.push({
      id: form['form_id'] ? form['form_id'] : 0,
      name: form['form_name'] ? form['form_name'] : form['form_name'],
      campaignId: form['campaign_id'],
      campaignName: form['campaign_name'] ? form['campaign_name'] : form['campaign_name'],
      actions: form['actions'],
      fields: form['fields'],
      createdAt: form['created_at'],
      listNames: form['list_names'],
      lastUpdated: form['last_updated'] ? form['last_updated'] : '',
      createdBy: form['created_by'],
      updatedBy: form['updated_by'],
      formUrl: form['form_url'] ? form['form_url'] : '',
      submissions: form['submissions'] ? form['submissions'] : 0,
    } as IFormData);
  }
  return forms;
};
